const en = {
  // Navigation
  "nav.top": "TOP",
  "nav.service": "Services",
  "nav.system": "System",
  "nav.flow": "How It Works",
  "nav.about": "About",
  "nav.contact": "Contact",
  "nav.privacy": "Privacy Policy",

  // Hero
  "hero.catchcopy": "Smarter Bank Transfer Management. Simpler. More Accurate.",
  "hero.sub": "We support payment management and fund management operations, and develop systems to streamline your business.",
  "hero.cta": "Our Services",
  "hero.cta2": "Contact Us",

  // TOP sections
  "top.about.label": "ABOUT US",
  "top.about.title": "About Stream Solutions Limited",
  "top.about.desc": "We provide comprehensive support for bank transfer-based payment management and fund management operations in Japan, along with system development to streamline these processes. We go beyond simple outsourcing by leveraging our proprietary systems to deliver integrated data linkage, automation, and visualization.",
  "top.about.btn": "Learn More",

  "top.services.label": "OUR SERVICES",
  "top.services.title": "Our Services",
  "top.services.sub": "From payment management to automated systems — all in one place.",

  "top.service1.title": "Payment Tracking",
  "top.service1.desc": "Real-time acquisition and management of incoming payment information.",
  "top.service2.title": "Reconciliation",
  "top.service2.desc": "Automated matching of transfer data, eliminating manual errors.",
  "top.service3.title": "Fund Settlement",
  "top.service3.desc": "Comprehensive support for fund organization and settlement operations.",
  "top.service4.title": "Reporting",
  "top.service4.desc": "Multi-dimensional data analysis and management reporting.",
  "top.service5.title": "Automation Systems",
  "top.service5.desc": "Development and provision of automated payment and accounting systems.",
  "top.service6.title": "Data Visualization",
  "top.service6.desc": "Real-time visualization of operational data to support decision-making.",

  "top.system.label": "SYSTEM",
  "top.system.title": "Proprietary Platform",
  "top.system.desc": "Our integrated platform delivers data linkage, automation, and visualization in a single solution, elevating your operational capabilities.",
  "top.system.btn": "Learn More",

  "top.cta.title": "Ready to Transform Your Operations?",
  "top.cta.sub": "From understanding your challenges to proposing the optimal solution, our expert team is here to help.",
  "top.cta.btn": "Contact Us",

  "top.stats.clients": "Clients",
  "top.stats.accuracy": "Accuracy",
  "top.stats.support": "Support",
  "top.stats.years": "Years Experience",

  // Service page
  "service.hero.title": "Our Services",
  "service.hero.sub": "Comprehensive support from payment management to automated system development.",
  "service.s1.title": "Payment Information Management",
  "service.s1.desc": "Real-time acquisition and management of bank account payment information. Centralized management of multiple accounts ensures accurate, up-to-date payment status at all times.",
  "service.s2.title": "Transfer Data Reconciliation",
  "service.s2.desc": "Automated matching of billing and payment data streamlines reconciliation. Eliminates manual errors and dramatically improves processing speed.",
  "service.s3.title": "Fund Organization & Settlement",
  "service.s3.desc": "Comprehensive support for fund flow organization and settlement operations. Handles complex fund management simply and accurately.",
  "service.s4.title": "Reporting & Analytics",
  "service.s4.desc": "Multi-dimensional analysis of operational data provides management-ready reports. Customizable dashboards visualize information at a glance.",
  "service.s5.title": "Payment & Accounting Automation",
  "service.s5.desc": "Our proprietary automation systems dramatically reduce the workload of payment and accounting operations. Simultaneously eliminates human error and improves efficiency.",
  "service.flow.title": "Service Delivery Process",
  "service.flow.sub": "Our dedicated team provides careful support from initial consultation to go-live.",

  // System page
  "system.hero.title": "Our System",
  "system.hero.sub": "Our proprietary platform delivers integrated data linkage, automation, and visualization.",
  "system.feature1.title": "Real-Time Data Integration",
  "system.feature1.desc": "Real-time integration with banking APIs enables instant acquisition and reflection of payment information.",
  "system.feature2.title": "AI Auto-Matching Engine",
  "system.feature2.desc": "A high-precision auto-matching engine powered by machine learning fully automates reconciliation.",
  "system.feature3.title": "Secure Cloud Infrastructure",
  "system.feature3.desc": "Cloud infrastructure compliant with financial-grade security standards keeps your data safe.",
  "system.feature4.title": "Customizable Dashboard",
  "system.feature4.desc": "A fully customizable dashboard visualizes KPIs in real time to match your operational needs.",
  "system.feature5.title": "API & System Integration",
  "system.feature5.desc": "API integration with existing accounting systems and ERPs enables seamless data unification.",
  "system.feature6.title": "Automated Report Generation",
  "system.feature6.desc": "Automatic generation and delivery of periodic reports reduces reporting workload to near zero.",
  "system.tech.title": "Technology Stack",
  "system.tech.sub": "We build scalable, reliable systems leveraging the latest technologies.",
  "system.cta.title": "See the System in Action",
  "system.cta.sub": "View actual system screens and confirm the impact of implementation for yourself.",
  "system.cta.btn": "Request a Demo",

  // Footer
  "footer.company": "Stream Solutions Limited",
  "footer.address.en": "Room D, Rm4. 2/F, Sunray Industrial Centre, 610 Cha Kwo Ling Road, Yau Tong, KL.",
  "footer.address.ja": "香港九龍油塘茶果嶺道610號 生利工業大廈2樓4室",
  "footer.tel": "+852-5321-3455",
  "footer.nav": "Navigation",
  "footer.contact_info": "Contact",
  "footer.copyright": "© 2024 Stream Solutions Limited. All rights reserved.",
  "footer.privacy": "Privacy Policy",
  "footer.tagline": "Smarter Bank Transfer Management. Simpler. More Accurate.",
};

export default en;
